import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import FormEditor from './FormEditor.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/forms'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'forms_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'forms_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'forms_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
        {
          path: 'new',
          name: 'forms_new',
          meta: {
            permissions: ['administrator'],
          },
          component: FormEditor,
        },
        {
          path: ':formId/edit',
          name: 'forms_edit',
          meta: {
            permissions: ['administrator'],
          },
          component: FormEditor,
          props: route => ({ formId: route.params.formId }),
        },
      ],
    },
  ],
};
